var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-flex',{staticClass:"center",attrs:{"shrink":"","align-self-center":""}},[_c('router',{attrs:{"routes":_vm.routes,"scene":_vm.scene}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }